module.exports = __webpack_public_path__ + "assets/img/pp_fc_hl.5e0708e8.svg";